module.exports = __webpack_public_path__ + "img/ofertas-cel.e313791d.jpg";